<template>
  <div>
    {{ id }}
    <vs-button
      radius
      class="mb-2 mr-4"
      color="dark"
      type="line"
      icon="visibility_off"
      style="float: right; opacity: 0.5"
      @click="hideandshowdetail(treesize)"
      v-if="locationdetails == true"
    ></vs-button>
    <vs-button
      radius
      class="mb-2 mr-4"
      color="dark"
      type="line"
      icon="visibility"
      style="float: right; opacity: 0.5"
      @click="hideandshowdetail(treesize)"
      v-if="locationdetails == false"
    ></vs-button>

    <vs-row vs-w="12">
      <vs-col :vs-lg="treesize">
        <vs-card style="border-radius: 15px; height: 100%">
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
              vs-w="6"
            >
              <h3>Location - {{ select1.location_name }}</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="center"
              vs-w="6"
            >
              <BtnAddLocation />
              <vs-select
                class="selectExample"
                v-model="select1"
                @change="changelocation"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.location_name"
                  v-for="(item, index) in PPlocation"
                />
              </vs-select>
            </vs-col>
          </vs-row>

          <div :key="treekey">
            <VueTree
              v-if="this.select1 != undefined"
              :location="this.select1"
              :locationall="this.PPlocation"
            />
          </div>

          <br />
          <!-- <DevextremeTreeList :location_id="this.select1.id" /> -->
        </vs-card>
      </vs-col>

      <vs-col vs-lg="5">
        <vs-card
          style="border-radius: 15px; height: 100%"
          v-if="locationdetails == true"
        >
          <div>
            <vs-row>
              <vs-spacer />
              <!-- <vs-button
                radius
                class="mb-1"
                style="opacity: 0.5"
                color="dark"
                type="line"
                icon="edit_location"
                v-b-modal.Add_Location
              ></vs-button> -->
              <div :key="treekey">
                <BtnSettingLocation
                  :locationselect="select1"
                  :provinces="province"
                />
              </div>
            </vs-row>

            <b-carousel
              id="carousel-fade"
              style="text-shadow: 0px 0px 2px #000"
              fade
              indicators
              img-width="1024"
            >
              <b-carousel-slide
                caption="First slide"
                img-src="https://picsum.photos/1024/480/?image=10"
              ></b-carousel-slide>
              <b-carousel-slide
                caption="Second Slide"
                img-src="https://picsum.photos/1024/480/?image=12"
              ></b-carousel-slide>
              <b-carousel-slide
                caption="Third Slide"
                img-src="https://picsum.photos/1024/480/?image=22"
              ></b-carousel-slide>
            </b-carousel>
          </div>
          <br />
          <br />

          <div style="text-align: center">
            <h1>Location - {{ select1.location_name }}</h1>
            <br />
            <br />
            <br />
            <div style="width: 400px; text-align: start" class="divcenter">
              <h4>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </h4>
              <br />
            </div>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import NumLocation from "./NumLocation.vue";
import NumAsset from "./NumAssetLocation.vue";
import NumSenSor from "./NumSensor.vue";
import NumGateWay from "./NumGateway.vue";
import LoSetting from "./LoSetting.vue";
import ListSenSor from "./ListSensor.vue";
import ListAlert from "./ListAlert.vue";
import VueTree from "../../../TreeListMaster/VueTreeList1.vue";
import BtnAddLocation from "@/TreeListMaster/button/BtnAddLocation";
import DevextremeTreeList from "@/TreeListMaster/DevextremeTree-List";
import BtnSettingLocation from "@/TreeListMaster/button/BtnSettingLocation";

export default {
  name: "NewLo",
  data() {
    return {
      treesize: 7,
      locationdetails: true,
      select1: undefined,
      PPlocation: [],
      id: localStorage.getItem("role"),
      treekey: 0,
      province: [],
      assetArr: {},
      //--TreeList DevExTreme
    };
  },
  components: {
    NumLocation,
    NumAsset,
    NumSenSor,
    NumGateWay,
    LoSetting,
    ListSenSor,
    ListAlert,
    VueTree,
    BtnAddLocation,
    DevextremeTreeList,
    BtnSettingLocation,
  },

  mounted() {
    this.getLocation();
    this.getALlAsset();
  },

  methods: {
    getProvince() {
      this.$API.get("location/get-province").then((res) => {
        console.log(res, "dd");
        this.province = res.data.data;
      });
    },
    changelocation() {
      console.log("1");
      this.treekey += 1;
    },
    hideandshowdetail(param) {
      console.log(param);
      if (param == 7) {
        this.treesize = 12;
        this.locationdetails = false;
      } else {
        this.treesize = 7;
        this.locationdetails = true;
      }
    },
    getLocation() {
      console.log("res");
      this.$API.get("location/get").then((res) => {
        console.log(res, "locationlog");
        this.PPlocation = res.data.result;
        this.select1 = this.PPlocation[0];
      });
    },
    getALlAsset() {
      this.$API.get("asset/all-attr-assets").then((res) => {
        this.assetArr = res.data;
      });
    },
  },
};
</script>

<style>
.tab-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: stretch;
}

.width-card {
  width: 100%;
}

.divcenter {
  margin-left: auto;
  margin-right: auto;
}
.main-container-fluid-lg {
  padding: 75px 15px 40px 15px;
}
</style>
